<template>
  <div class="bg--white">
    <SectionEditoSimple
      :card-props="{color: 'light-blue', class: 'symbol-top' }"
      style="padding-top: 2.19rem"
    >
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="capsule purple">
            {{ edito.capsule }}
          </div>
          <HEditoTitle
            :first-part="edito.title.firstPart"
            :second-part="edito.title.secondPart"
            :last-part="edito.title.lastPart"
            class="mb-10"
          />
          <HSubTitle
            class="mb-2"
            :font-family="'Hanken Grotesk, sans-serif'"
          >
            <HH5>{{ edito.subtitle }}</HH5>
          </HSubTitle>
          <SvgMeilleurTauxLogo class="logo-meilleurtaux" />
        </div>
      </div>
    </SectionEditoSimple>
    <HTrustInOurPartnerCard
      :data="trustInOurPartner"
    />
    <div class=" section-rounded section-rounded--grey section-padding--top">
      <div class="container">
        <div class="row">
          <div class="col-12 m-auto">
            <iframe
              id="mtiframe"
              class="full-width-iframe"
              src="https://www.meilleurtaux.com/calculatrice/calcul_mensualites_v3/?IDAPPORTEUR=PARTENAIRE_CALCULETTE_HOMELOOP&at_medium=affiliate&at_campaign=homeloop&at_type=calculatrice_calcul_mensualite&at_identifier=homeloop_externe&at_format=redirection"
              frameborder="0"
              scrolling="no"
              style="overflow: hidden;"
              @load="iframeLoaded"
              @error="iframeLoaded"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section-rounded section-rounded--white">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-12 col-lg-6 m-auto">
            <HSectionTitle v-bind="meilleurTauxProps.titleProps" />
          </div>
        </div>
        <div class="row">
          <div class="col-10 m-auto">
            <div class="row">
              <div
                v-for="item of meilleurTauxProps.items"
                :key="item.title"
                class="col-12 col-md-4 py-2"
              >
                <HNumberCard
                  :title="item.title"
                  :text="item.text"
                  :class="`cardMeilleurtaux pt-6 ${item.class}`"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class=" section-rounded section-rounded--grey">
      <div class="container">
        <div class="v-row section-padding--bottom">
          <div class="v-col-12 v-col-md-6">
            <HSectionTitle v-bind="yourProjectImmo.titleProps" />
            <div class="yourProjectImmo mt-4">
              <p class="mb-3">
                Le financement est une étape clé dans l’acquisition d’un bien, et en particulier en ce moment.
              </p>
              <p>
                C’est pourquoi homeloop a décidé de vous simplifier son obtention en s’alliant avec le leader du marché :
              </p>
              <p>
                <strong>
                  meilleurtaux.com
                </strong>
              </p>
            </div>
          </div>
          <div class="v-col-12 v-col-md-6">
            <div class="row row-height-10">
              <VImg
                src="~/assets/img/interfaceMeilleurtaux.svg"
                alt="interface_meilleurtaux"
                class="meilleurtauxImg"
              />
            </div>
            <div class="row row-height-2" />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12 m-auto">
            <HCard
              color="night-blue"
              class="text-center"
              use-bottom-block
            >
              <div class="row mb-4">
                <div class="col-12">
                  <HH2 color="white">
                    On t'attend !
                  </HH2>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                  <p>Tu aimes ce que tu as lu ? Tu te reconnais en homeloop ? Ton cœur bat à l’idée de rejoindre notre belle équipe ? Rejoins-nous sans plus attendre et révolutionne le monde de l'immobilier ! </p>
                  <p class="text--intro">
                    Choisis l'équipe dans laquelle tu veux travailler et découvre nos postes ouverts.
                  </p>
                  <HButton
                    color="purple"
                    class="mt-4"
                    tag="link"
                    target="_blank"
                    to="https://www.welcometothejungle.com/fr/companies/homeloop/jobs"
                    block-on-mobile
                  >
                    Voir toutes nos offres d’emplois !
                  </HButton>
                </div>
              </div>
              <template #bottom>
                <div class="row">
                  <div class="col-12 col-lg-11 m-auto">
                    <div class="row justify-content-between">
                      <div
                        v-for="(n) in shuffledEmployees"
                        :key="n"
                        class="col-auto"
                      >
                        <VImg
                          :src="n.avatar_url"
                          class="avatar"
                          cover
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </HCard>
          </div>
        </div> -->
        <div class="container">
          <div class="row">
            <div class="col-12">
              <HCard
                color="pink"
                no-padding
                style="padding: 1.875rem;"
              >
                <div class="row align-items-center">
                  <div class="col-12 col-lg-4 mb-4 mb-lg-0">
                    <p style="font-size: 1.875rem;line-height: 1; font-weight: 500; margin: 0;">
                      Je veux vendre mon bien avec homeloop !
                    </p>
                  </div>
                  <div class="col d-flex justify-content-end">
                    <HButton
                      style="border: 1px solid #fff"
                      tag="link"
                      target="_blank"
                      to="mailto:contact@homeloop.fr"
                      block-on-mobile
                    >
                      Contactez-nous
                    </HButton>
                  </div>
                </div>
              </HCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { iframeResizer } from 'iframe-resizer'
import _ from 'lodash'
import SvgCheck from '~/components/svg/Check.vue'
import SvgSmiley from '~/components/svg/Smiley.vue'
import SvgEuro from '~/components/svg/Euro.vue'

function iframeLoaded () {
  iframeResizer({ log: true }, '#mtiframe')
}

const yourProjectImmo = ref({
  titleProps: {
    firstPart: 'Bouclez votre projet',
    secondPart: '<br>immobillier',
    lastPart: ''
  }
})

const trustInOurPartner = ref({
  title: {
    firstPart: 'Pourquoi faire confiance<br>',
    secondPart: 'à notre partenaire<br>MeilleurTaux',
    lastPart: '?'
  },
  reasons: [
    {
      title: 'Faites des économies',
      icon: SvgEuro,
      text: 'Gratuit et sans engagement, Meilleurtaux vous trouverez les meilleurs accords bancaires du marché. En 2022, Meilleurtaux a permis à ses clients de réaliser 160 000 000 € d’économies sur leur crédit immobilier !'
    },
    {
      title: 'Trouvez le meilleur taux',
      icon: SvgCheck,
      text: 'En lien direct et quotidien avec les plus grands partenaires bancaires, Meilleurtaux est en mesure de vous trouver le meilleur taux du marché.'
    },
    {
      title: 'Simplifiez-vous la vie',
      icon: SvgSmiley,
      text: 'Un seul interlocuteur pour vous accompagner et défendre votre dossier auprès de + de 125 partenaires bancaires.'
    }
  ]
})

const meilleurTauxProps = ref({
  titleProps: {
    firstPart: 'MeilleurTaux,',
    secondPart: " c'est",
    lastPart: ''
  },
  items: [
    {
      title: '360',
      text: 'agences'
    },
    {
      title: '+2000',
      text: 'conseillers'
    },
    {
      title: '3 000 000',
      text: 'de clients en 2023',
      class: 'p-3'
    }
  ]
})

const { data: employees } = await useAsyncData('employees', async () => {
  return await getService('employees').find({
    query: {
      active: true,
      listed_on_website: true,
      $limit: -1
    }
  })
})

const shuffledEmployees = computed(() => _.shuffle(employees.value))
shuffledEmployees.value.length = 6

const edito = ref({
  capsule: 'Financement',
  title: {
    firstPart: 'Financez votre projet<br> de manière ',
    secondPart: 'simple,<br> rapide et sécurisée ',
    lastPart: '!'
  },
  subtitle: 'Avec notre partenaire :'
})

</script>

<style lang="scss" scoped>

.cardTrustInOurPartner{
  border-radius: 10px;
  padding: 16px;
  background-color: #F5F6FB;
}

.cardMeilleurtaux {
  @include media-breakpoint-down(lg) {
    padding-left: 15px!important;
  }
}

.yourProjectImmo {
  max-width: 520px;
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: left;
}

.logo-meilleurtaux {
  display: inline-block;
  height: 51px;
  vertical-align: baseline;
  width: auto;

  @include media-breakpoint-down(md) {
    height: 37px;
  }
}

.full-width-iframe {
  width: 100%;
  height: 1235px;
  border: solid 50px white;
  border-radius: 10px;

  @include media-breakpoint-down(md) {
    height: 1750px;
    border: solid 20px white;
  }
}

.avatar {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #ededeb;

  @include media-breakpoint-down(xl) {
    width: 60px;
    height: 60px;
  }
}

.row-height-2 {
  height: calc(100% / 6);
}

.row-height-10 {
  height: calc(100% / 3 * 2.5);
}

</style>
